export const IconEnums = {
  user: {
    icon: 'UserIcon',
    color: '#282828', // black
  },
  content: {
    icon: 'MessageSquareIcon',
    color: '#8012c3', // purple
  },
  like: {
    icon: 'HeartIcon',
    color: '#d93a57', // red
  },
  createdAt: {
    icon: 'CalendarIcon',
    color: '#282828', // dark gray
  },
  updatedAt: {
    icon: 'CalendarIcon',
    color: '#282828', // dark gray
  },
  keywords: {
    icon: 'KeyIcon',
    color: '#282828', // dark gray
  },
  title: {
    icon: 'AlignJustifyIcon',
    color: '#282828', // dark gray
  },
  tags: {
    icon: 'TagIcon',
    color: '#282828', // dark gray
  },
  actions: {
    icon: 'SlidersIcon',
    color: '#282828', // dark gray
  },
  category: {
    icon: 'GridIcon',
    color: '#282828', // dark gray
  },
}

export default IconEnums
